import { call, put, takeLatest } from 'redux-saga/effects';
import { MOVE_TO_ANOTHER_GATEWAY_REQUEST, VALIDATE_GATEWAY_ASSET_REQUEST } from './constants';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { notify } from 'sharedComponents/GeneralNotification';
import { actionTypes } from '../../../constants';
import { getAssetMoveToAnotherGatewayAction, getAssetValidationGatewayAction } from './actions';
function* moveToAnotherGatewaySaga(action) {
    yield put(getAssetMoveToAnotherGatewayAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.moveGatewayAsset, action.driveSerialNumber, action.gatewaySerialNumber, action.driveAddress);
        if (response?.success) {
            yield put(getAssetMoveToAnotherGatewayAction(apiCallStatus.SUCCESS));
            notify(translate('ABB.Powertrain.Frontend.AssetMovedSuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
        } else if (response?.error) {
            notify(response?.error?.message, NOTIFICATION_TYPES.ERROR, true);
        }
        yield put({
            type: actionTypes.GET_GATEWAY_CONNECTED_ASSETS,
            payload: { gatewayID: action.gatewayId }
        });
        if (typeof action.onResetAssetInfo === 'function') {
            yield call(action.onResetAssetInfo);
        }

    } catch (error) {
        yield put(getAssetMoveToAnotherGatewayAction(apiCallStatus.ERROR, [], error));
    }
}
function* validateGatewayAssetSaga(action) {
    yield put(getAssetValidationGatewayAction(apiCallStatus.LOADING));
    try {
        const result = yield call(GatewayManagementApi.validateGatewayAsset, action.driveSerialNumber, action.gatewaySerialNumber, action.driveAddress);
        yield put(getAssetValidationGatewayAction(apiCallStatus.SUCCESS, result));
    } catch (error) {
        yield put(getAssetValidationGatewayAction(apiCallStatus.ERROR, [], error));
    }
}
export function* ValidateAssetGatewayWatchers() {
    yield takeLatest(VALIDATE_GATEWAY_ASSET_REQUEST, validateGatewayAssetSaga);
}
export function* MoveToAnotherGatewayWatchers() {
    yield takeLatest(MOVE_TO_ANOTHER_GATEWAY_REQUEST, moveToAnotherGatewaySaga);
}
